import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {find, pick, isArray, remove, findIndex, map} from 'lodash';
import {Vue} from 'vue-property-decorator';

export interface IBadgeStoreState {
	badges: IBadge[];
}

export interface IBadge {
	badgeId: string;
	locationId: string;
	name: string;
	modId: number;
	activationDate: number;
	lastSeenDate: number;
}

export interface ILocalBadge {
	name: string;
	badgeId: string;
	ticketId: string | null;
	state: 'OPEN' | 'VIEWED' | 'SENT' | 'UNDERPAID' | 'PAID' | 'CANCELLED' | 'UNASSIGNED';
	placeholder: boolean;
}


@Module({dynamic: true, store, name: 'badge', namespaced: true})
class Badge extends VuexModule implements IBadgeStoreState {
	badges: IBadge[] = [];

	public static mergeAndAdd(existingItems: any[], newItems: any[], predicateKeys: string[]) {
		newItems.forEach((newItem) => {
			const existingItemIndex = findIndex(existingItems, pick(newItem, predicateKeys));
			if(existingItemIndex > -1) {
				Vue.set(existingItems, existingItemIndex, Object.assign({}, existingItems[existingItemIndex], newItem));
			} else {
				existingItems.push(newItem);
			}
		});
	}

	get byId() {
		return (badgeId: string) => {
			return find(this.badges, {badgeId: badgeId}) || null;
		};
	}

	get sortedByName() {
		return this.badges.sort((a, b) => {
			return a.name.localeCompare(b.name, undefined, {
				numeric: true,
				sensitivity: 'base'
			});
		});
	}

	get isValidBadgeName() {
		return (name: string) => {
			return name.trim() !== '' && map(this.badges, 'name').indexOf(name.trim()) === -1;
		};
	}

	@Action
	public addOrUpdateBadge(badge: IBadge | IBadge[]) {
		if(!isArray(badge)) {
			badge = [badge];
		} else {
			this.CLEAR_BADGES();
		}
		this.ADD_OR_UPDATE_BADGE(badge);
	}

	@Action
	public removeBadge(folioId: string) {
		this.REMOVE_BADGE(folioId);
	}


	@Action
	public clearBadges() {
		this.CLEAR_BADGES();
	}

	@Mutation
	public ADD_OR_UPDATE_BADGE(badges: IBadge[]) {
		Badge.mergeAndAdd(this.badges, badges, ['badgeId']);
	}

	@Mutation
	public REMOVE_BADGE(badgeId: string) {
		const foundIndex = findIndex(this.badges, {badgeId: badgeId});
		if(foundIndex !== -1) {
			this.badges.splice(foundIndex, 1);
		}
	}

	@Mutation
	public CLEAR_BADGES() {
		this.badges = [];
	}
}

export const BadgeStore = getModule(Badge);
